module.exports = __webpack_public_path__ + "img/publish.853591e.png";